/**
 * Attestation generation functions
 * Reusable across admin and master admin contexts
 */

/**
 * Initialize attestation functionality
 * @param {Object} config - Configuration object with routes
 * @param {string} config.getContentGroupsRoute - Route to fetch content groups
 * @param {string} config.generateArchiveRoute - Route to generate attestation archive
 * @param {Object} config.translations - Translation strings
 * @param {string} config.clientId - Optional client ID for master admin context
 */
export function initializeAttestations(config) {
    const {
        getContentGroupsRoute,
        generateArchiveRoute,
        translations,
        clientId = null
    } = config;

    // Function to show content groups popup
    window.showContentGroupsPopup = function() {
        const popup = document.getElementById('contentGroupsPopup');
        const loading = document.getElementById('contentGroupsLoading');
        const list = document.getElementById('contentGroupsList');
        const noGroups = document.getElementById('noContentGroups');
        
        // Show popup and loading state
        popup.classList.remove('hidden');
        loading.classList.remove('hidden');
        list.classList.add('hidden');
        noGroups.classList.add('hidden');
        
        // Fetch content groups
        fetch(getContentGroupsRoute, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => {
            loading.classList.add('hidden');
            
            if (data.contentGroups && data.contentGroups.length > 0) {
                // Populate content groups list
                const listHtml = data.contentGroups.map(group => {
                    const archivedBadge = group.is_archived
                        ? `<span class="ml-2 inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 border border-yellow-300"><i class="ph ph-archive text-xs"></i> ${translations.archived || 'Archivé'}</span>`
                        : '';
                    return `
                    <div class="flex items-center">
                        <input id="cg_${group.id}"
                               type="checkbox"
                               value="${group.id}"
                               name="content_groups[]"
                               class="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded">
                        <label for="cg_${group.id}" class="ml-3 text-sm font-medium text-gray-700">
                            ${group.name}
                            <span class="text-gray-500 font-normal">(${group.type})</span>
                            ${archivedBadge}
                        </label>
                    </div>
                    `;
                }).join('');
                
                list.innerHTML = listHtml;
                list.classList.remove('hidden');
            } else {
                noGroups.classList.remove('hidden');
            }
        })
        .catch(error => {
            console.error('Error fetching content groups:', error);
            loading.classList.add('hidden');
            noGroups.classList.add('hidden');
        });
    };

    // Function to close content groups popup
    window.closeContentGroupsPopup = function() {
        document.getElementById('contentGroupsPopup').classList.add('hidden');
    };

    // Function to generate attestations for selected content groups
    window.generateSelectedAttestations = function() {
        const checkboxes = document.querySelectorAll('#contentGroupsList input[type="checkbox"]:checked');
        
        if (checkboxes.length === 0) {
            alert(translations.select_at_least_one);
            return;
        }
        
        const selectedIds = Array.from(checkboxes).map(cb => cb.value);
        
        // Show loading state
        const submitBtn = document.querySelector('#contentGroupsPopup button[onclick="generateSelectedAttestations()"]');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = translations.generation_in_progress;
        submitBtn.disabled = true;
        
        // Prepare form data
        const formData = new FormData();
        formData.append('_token', document.querySelector('meta[name="csrf-token"]').content);
        
        // Add client_id for master admin context
        if (clientId) {
            formData.append('client_id', clientId);
        }
        
        selectedIds.forEach(id => {
            formData.append('content_groups[]', id);
        });
        
        // Add current URL filters to the request (for filtered attestation generation)
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach((value, key) => {
            // Skip pagination params, only include filter params
            if (key !== 'page' && key !== 'per_page') {
                formData.append(key, value);
            }
        });
        
        // Send AJAX request
        fetch(generateArchiveRoute, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            // Reset button state
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
            
            // Close popup
            window.closeContentGroupsPopup();
            
            // Show message
            if (data.success) {
                alert(data.message);
            } else {
                alert('Erreur: ' + (data.message || 'Erreur inconnue'));
            }
        })
        .catch(error => {
            console.error('Error:', error);
            
            // Reset button state
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
            
            // Close popup and show error
            window.closeContentGroupsPopup();
            alert(translations.attestation_generation_error);
        });
    };

    // Close popup when clicking outside
    document.addEventListener('click', function(event) {
        const popup = document.getElementById('contentGroupsPopup');
        if (event.target === popup) {
            window.closeContentGroupsPopup();
        }
    });
}

